
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker } from '@/components';
import { useQuestItemTime } from '@/modules/quest/item/model/time';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.ITEM.TIME,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, actions } = useQuestItemTime();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
